import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Checkbox from "@material-ui/core/Checkbox";
import GridItem from "components/Grid/GridItem.js";
import QuantityButtons from "components/CustomButtonGroup/QuantityButtons";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { width } from "@mui/system";

const BlueCheckbox = withStyles({
  root: {
    color: "#03A9F4",
    padding: "0 7px 0 0",
    "&$checked": {
      color: "#03A9F4"
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const styles = {
  cardCategory: {
    fontFamily: "Montserrat, sans-serif",
    color: "#999494",
    textAlign: "center",
  },
  cardTitle: {
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 500,
    textAlign: "center",
  },
  borderCard: {
    borderTop: "5px solid #03A9F4!important"
  },
  precoPE: {
    fontFamily: "Montserrat, sans-serif",
    marginBottom: 0,
    textAlign: "right",
    fontSize: "17px",
    color: "#03A9F4"
  },
  btnComprarNew: {
    backgroundColor: "green",
    width: "100%",
  }
};

const useStyles = makeStyles(styles);

export const CardPedido = props => {
  const { descricao, titulo, pedidoId, valorTotal } = props;
  const classes = useStyles();

  /* const handleCheck = e => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
    changeCheck(isChecked, prod.Guid);
  }; */

  return (
    <GridItem xs={12} sm={12} md={4}>
      <Card className={classes.borderCard}>
        <CardBody>
          <div>
            <p className={classes.cardCategory}>Pedido {pedidoId}</p>
          </div>
          <h4 className={classes.cardTitle}>
            {/* <BlueCheckbox
              checked={checkPE.get(prod.Guid)}
              value={prod.Guid}
              name={prod.Guid}
              onChange={handleCheck}
            /> */}
            {titulo}
          </h4>
          <p className={classes.cardCategory}>{descricao}</p>
          {/* <QuantityButtons change={changeQuant} id={prod.Guid} /> */}
          {/* {isCheck ? (
            <QuantityButtons change={changeQuant} id={prod.Guid} />
          ) : (
            ""
          )} */}
          <p className={classes.precoPE}>Valor total: {valorTotal}</p>
        </CardBody>
        <CardFooter chart>
            <Link to={`venda/pedido/contrato/${pedidoId}`} style={{ width: "100%" }}>
                <Button className={classes.btnComprarNew} variant="contained" color="primary">Pagar</Button>
            </Link>
        </CardFooter>
      </Card>
    </GridItem>
  );
};